import {createTheme, responsiveFontSizes} from "@mui/material";

// Palette : noir/nuit (identité Mouch'Paba) + bleu glacier (#89d9e4) + rouge course
export const colors = {
    night: "#0b1220",
    night2: "#121c2f",
    glacier: "#89d9e4",
    glacierDark: "#56a7b2",
    red: "#e63946",
    snow: "#f5f8fb",
    muted: "#5b6678",
};

export const displayFont = '"Bebas Neue", Impact, "Arial Narrow", sans-serif';

export const theme = responsiveFontSizes(createTheme({
    palette: {
        primary: {light: "#2c2c2c", main: "#000000", dark: "#000000", contrastText: colors.glacier},
        secondary: {light: "#bcffff", main: colors.glacier, dark: colors.glacierDark, contrastText: "#000"},
        error: {main: colors.red},
        background: {default: colors.snow, paper: "#ffffff"},
        text: {primary: colors.night, secondary: colors.muted},
    },
    shape: {borderRadius: 4},
    typography: {
        fontFamily: '"Inter", "Roboto", system-ui, sans-serif',
        h1: {fontFamily: displayFont, letterSpacing: "0.02em", lineHeight: 0.95},
        h2: {fontFamily: displayFont, letterSpacing: "0.02em", lineHeight: 1},
        h3: {fontFamily: displayFont, letterSpacing: "0.02em"},
        h4: {fontFamily: displayFont, letterSpacing: "0.02em"},
        button: {textTransform: "none", fontWeight: 700},
    },
    components: {
        MuiButton: {
            defaultProps: {disableElevation: true},
            styleOverrides: {root: {borderRadius: 999, padding: "10px 24px"}},
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 20,
                    boxShadow: "0 10px 30px rgba(11,18,32,.08)",
                    transition: "transform .35s ease, box-shadow .35s ease",
                    "&:hover": {transform: "translateY(-4px)", boxShadow: "0 18px 40px rgba(11,18,32,.14)"},
                },
            },
        },
    },
}));
